import React from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "../Shared/Footer/Footer";

const NotFound = () => {
  const { pathname } = useLocation();

  return (
    <div className="portfolio-home">
      <header className="site-nav site-nav--minimal" aria-label="Site">
        <Link className="site-nav__brand" to="/">
          Hassan Zahar Rifat
        </Link>
        <a className="site-nav__email" href="mailto:hz.rifat@gmail.com">
          hz.rifat@gmail.com
        </a>
      </header>

      <main className="not-found">
        <p className="not-found__code">404</p>
        <h1 className="not-found__title">This page isn’t on the map.</h1>
        <p className="not-found__lead">
          The URL may be mistyped, or the page may have moved. If you followed
          a link from elsewhere, it might be out of date.
        </p>
        <p className="not-found__path" aria-label="Requested path">
          <span className="not-found__path-label">Requested</span>
          <code>{pathname}</code>
        </p>
        <div className="not-found__actions">
          <Link className="not-found__btn" to="/">
            Back to home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
